import { LAYOUTS } from '@/App.vue'
import ROUTE_NAMES from './route-names'

const {
  checkout,
  checkoutRegistration,
  checkoutRegistrationAliases,
  checkoutShipping,
  checkoutShippingAliases,
  checkoutPayment,
  checkoutPaymentAliases,
  checkoutConfirmation,
  cyclon,
  comparison,
  onStore,
  onStoreNYC,
  pageNotFound,
  serverError,
  unprocessableEntity,
  product,
  roger,
  demoSizing,
  demo,
  demoForm,
  demoDyApi,
  home,
  npsFeedback,
  ownerCardRegistration,
  raffleEntryUpdate,
  raffleEntryCreate,
  raffleConfirmation,
  productReviews,
  shoeFinder,
} = ROUTE_NAMES

export default [
  {
    path: `/${checkout}`,
    name: checkout,
    meta: { layout: LAYOUTS.simple },
    component: () => {
      return import(/* webpackChunkName: "checkout-v2" */ '@/views/Checkout.vue')
    },
    children: [
      {
        path: `${checkoutRegistration}`,
        alias: checkoutRegistrationAliases,
        name: checkoutRegistration,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "registration" */ '@/views/Checkout/Registration.vue')
        },
      },
      {
        path: `${checkoutShipping}/:scrollAnchor?`,
        alias: checkoutShippingAliases.map(alias => {
          return `${alias}/:scrollAnchor?`
        }),
        name: checkoutShipping,
        meta: { layout: LAYOUTS.simple, modifier: 'bottom-margin' },
        component: () => {
          return import(/* webpackChunkName: "shipping" */ '@/views/Checkout/Shipping.vue')
        },
        props: true,
      },
      {
        path: `${checkoutPayment}/:scrollAnchor?`,
        alias: checkoutPaymentAliases.map(alias => {
          return `${alias}/:scrollAnchor?`
        }),
        name: checkoutPayment,
        meta: { layout: LAYOUTS.simple, modifier: 'bottom-margin' },
        component: () => {
          return import(/* webpackChunkName: "payment" */ '@/views/Checkout/Payment.vue')
        },
        props: true,
      },
      {
        path: `${checkoutConfirmation}/:orderNumber`,
        name: checkoutConfirmation,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "confirmation" */ '@/views/Checkout/Confirmation.vue')
        },
      },
    ],
  },
  {
    path: `/${product}/:productGroup/:gender?/:colors?`,
    name: product,
    meta: { isTrackingVirtPathInView: true },
    component: () => {
      return import(/* webpackChunkName: "product-page" */ '@/views/ProductPage.vue')
    },
  },
  {
    path: `/${cyclon}`,
    name: cyclon,
    component: () => {
      return import(/* webpackChunkName: "cyclon" */ '@/views/Cyclon.vue')
    },
  },
  {
    path: `/${comparison}/:productGroup?`,
    name: comparison,
    component: () => {
      return import(/* webpackChunkName: "comparison" */ '@/views/Comparison.vue')
    },
  },
  {
    path: `/${onStore}`,
    component: () => {
      return import(/* webpackChunkName: "on-store" */ '@/views/OnStore.vue')
    },
    children: [
      {
        path: '',
        name: onStore,
        component: () => {
          return import(/* webpackChunkName: "page-not-found" */ '@/views/PageNotFound.vue')
        },
      },
      {
        path: `${onStoreNYC}`,
        name: onStoreNYC,
        meta: { layout: LAYOUTS.blank },
        component: () => {
          // This route should not go live yet
          // return import(/* webpackChunkName: "on-store-nyc" */ '@/views/OnStore/NYC.vue')
          return import(/* webpackChunkName: "page-not-found" */ '@/views/PageNotFound.vue')
        },
      },
    ],
  },
  {
    path: `/${roger}`,
    name: roger,
    component: () => {
      return import(/* webpackChunkName: "roger" */ '@/views/Roger.vue')
    },
  },
  {
    path: `/`,
    name: home,
    component: () => {
      return import(/* webpackChunkName: "home" */ '@/views/Home.vue')
    },
  },
  {
    path: `/${npsFeedback}`,
    name: npsFeedback,
    component: () => {
      return import(/* webpackChunkName: "nps" */ '@/views/Nps.vue')
    },
  },
  {
    path: `/${shoeFinder}/:productGroup?`,
    name: shoeFinder,
    component: () => {
      return import(/* webpackChunkName: "shoe-finder" */ '@/views/ShoeFinder.vue')
    },
  },
  {
    path: `/${raffleEntryCreate}/:variantId`,
    name: raffleEntryCreate,
    meta: { layout: LAYOUTS.simple },
    component: () => {
      return import(/* webpackChunkName: "entry" */ '@/views/Raffle/Entry.vue')
    },
    props: route => ({ variantId: route.params.variantId }),
  },
  {
    path: `/${raffleEntryUpdate}/:raffleId`,
    name: raffleEntryUpdate,
    meta: { layout: LAYOUTS.simple },
    component: () => {
      return import(/* webpackChunkName: "entry" */ '@/views/Raffle/Entry.vue')
    },
    props: route => ({ raffleId: route.params.raffleId }),
  },
  {
    path: `/${raffleConfirmation}/:raffleId`,
    name: raffleConfirmation,
    meta: { layout: LAYOUTS.simple },
    component: () => {
      return import(/* webpackChunkName: "confirmation" */ '@/views/Raffle/Confirmation.vue')
    },
  },
  {
    path: `/${ownerCardRegistration}`,
    name: ownerCardRegistration,
    component: () => {
      return import(
        /* webpackChunkName: "owner-card-registration" */ '@/views/OwnerCardRegistration.vue'
      )
    },
  },
  {
    path: `/${productReviews}/:reviewId`,
    name: productReviews,
    component: () => {
      return import(/* webpackChunkName: "productReviews" */ '@/views/ProductReview.vue')
    },
    props: route => ({ reviewId: route.params.reviewId }),
  },
  {
    path: `/${demo}`,
    component: () => {
      return import(/* webpackChunkName: "demo" */ '@/views/Demo/Demo.vue')
    },
    children: [
      {
        path: '',
        name: demo,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(
            /* webpackChunkName: "demo-table-of-content" */ '@/views/Demo/DemoTableOfContent.vue'
          )
        },
      },
      {
        path: `${demoForm}`,
        name: demoForm,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "demo-form" */ '@/views/Demo/DemoForm.vue')
        },
      },
      {
        path: `${demoSizing}`,
        name: demoSizing,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "demo-sizing" */ '@/views/Demo/DemoSizing.vue')
        },
      },
      {
        path: `${demoDyApi.replace(/^demo-/, '')}`,
        name: demoDyApi,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "demo-dy-api" */ '@/views/Demo/DemoDyApi.vue')
        },
      },
    ],
  },
  {
    path: `/${pageNotFound}`,
    alias: [`/${unprocessableEntity}`, `/${serverError}`, '*'],
    name: pageNotFound,
    component: () => {
      return import(/* webpackChunkName: "page-not-found" */ '@/views/PageNotFound.vue')
    },
  },
]
